import React from 'react';
import { useHistory } from 'react-router-dom';
import LangSelect from '../multiLang/multiLang';
import { useTranslation } from 'react-i18next';

const Header = () => {
    const history = useHistory();

    const { t } = useTranslation('header');
    const { t: isLang } = useTranslation('type');

    return (
        <>
            <header className='header'>
                <a className='logo ir_pm' href='/'>
                    Go to the Home
                </a>
                <div className='nav__menu'>
                    <div className='hamburger'>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <nav className='nav'>
                    <ul className='nav__list'>
                        <li className='nav__item mobile'>
                            <a href='/'>{t('downloadApp')}</a>
                        </li>
                        <li className='nav__item'>
                            <a href='/help'>{t('help')}</a>
                        </li>
                        <li className='nav__item'>
                            <a href='/alliance'>{t('alliance')}</a>
                        </li>
                        {isLang('lang') !== 'en' && (
                            <li className='nav__item'>
                                <a href='/pricing'>가격</a>
                            </li>
                        )}
                        <li className='nav__item'>
                            <a target='_blank' href='https://www.salin.co.kr'>
                                SALIN<span className='arrow'>↗</span>
                            </a>
                        </li>
                    </ul>
                    <LangSelect />
                </nav>
            </header>
            {/* <div className="top-bar">
        <a href="/voucher" target="_blank">
          <img
            src="./assets/icon/icon_government.png"
            alt="South Korea government"
          />
          정부 지원금 안내<ion-icon name="open-outline"></ion-icon>
        </a>
      </div> */}
        </>
    );
};

export default Header;
